export default __webpack_public_path__ + "static/media/IconDesc_PolymerResin.256.20ef2208.png";